export default __webpack_public_path__ + "images/models/49f6e65cf86594414efc35b47c6784c3.glb";